import React from 'react';
import {
    Input,
    InputGroup,
    FormControl,
    CheckOutlined,
    Box,
    Paragraph,
    Button,
} from '@landr/maestro';
import { Trans } from '@lingui/macro';
import { css } from '@landr/styled-system/css';

const copyButtonStyles = css({
    width: '72px',
    '& > svg': {
        margin: '0!important',
    },
});

export const ShareModalReady: React.FC<{
    creatorUrl: string;
    hasBeenCopied: boolean;
    onClick: () => void;
}> = ({ creatorUrl, hasBeenCopied, onClick }): JSX.Element => (
    <>
        <Paragraph color="text.medium">
            <Trans>
                Copy the link to share your track with friends, fans and
                collaborators.
            </Trans>
        </Paragraph>
        <FormControl isValid={hasBeenCopied} isReadOnly>
            <Box
                display="flex"
                flexDirection="column"
                alignItems="flex-end"
                width="100%"
            >
                <InputGroup width="100%">
                    <Input value={creatorUrl} />
                    <InputGroup.Addon placement="right">
                        <Button
                            variant="primary"
                            size="sm"
                            className={copyButtonStyles}
                            onClick={onClick}
                        >
                            {hasBeenCopied ? (
                                <CheckOutlined />
                            ) : (
                                <Trans>Copy</Trans>
                            )}
                        </Button>
                    </InputGroup.Addon>
                </InputGroup>
                <FormControl.ValidationMessage>
                    <Trans>Copied to clipboard!</Trans>
                </FormControl.ValidationMessage>
            </Box>
        </FormControl>
    </>
);
